import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const transfloConfig: TSPConfig = {
  key: 'transflo',
  name: 'Transflo',
  category: TSPCategory.CUSTOM,
  helpText: (
    <>
      <p>
        To connect to Transflo DMS, you’ll need to provide your{' '}
        <strong>Username</strong>, <strong>Password</strong>, and{' '}
        <strong>Database Name</strong>.
      </p>

      <p>
        <strong>Username & Password:</strong> Use the same credentials you use
        to log into the Transflo DMS system. If you're unsure of your login
        details, contact your system administrator or Transflo support.
      </p>

      <p>
        <strong>Database Name:</strong> This identifies the specific database
        your Transflo instance connects to.
      </p>
      <p>You can find it by:</p>
      <ul>
        <li>
          Opening the <em>Transflo DMS Administration Tool</em>
        </li>
        <li>
          Navigating to the <strong>Credential Manager</strong> section
        </li>
        <li>
          Looking for the <strong>Database Name</strong> listed alongside your
          credentials
        </li>
      </ul>

      <p>
        If you can’t locate the database name, please reach out to your system
        administrator or Transflo support for assistance.
      </p>
    </>
  ),
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
        {
          label: 'Database Name',
          name: 'database',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default transfloConfig;
